import script from "./MicroLearningCampaignView.vue?vue&type=script&setup=true&lang=js"
export * from "./MicroLearningCampaignView.vue?vue&type=script&setup=true&lang=js"

import "./MicroLearningCampaignView.vue?vue&type=style&index=0&id=70453f58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70453f58"]])

export default __exports__